import { useCallback, useEffect, useState } from "react";

import { useNavigate, useSearchParams } from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";

import RightChevron from "../../../../../src/assets/images/chevron-left-color.svg";
import ProgressBar from "../../../../shared/LinearProgressBar";

import Button from "../ButtonComponent";

import HeaderModule from "../ModuleHeaderComponent";

import { BUTTON_VARIANTS } from "../constant";

import styles from "./styles.module.scss";

import { useGetPostChapterAssessmentQuestion } from "./queries";
import { useSavePostChapterAssessment } from "./mutation";
import CourseQuestionCards from "../CourseQuestionCards";
import ChapterCompleteSuccessfulComponent from "../ChapterSuccessfulComponent";
import AssessmentExitModal from "../AssessmentExitModal";
import { ASSESSMENT_ALLOWED, LMS_CHAPTER_ID, LMS_CHAPTER_NAME, LMS_COURSE_ID, LMS_COURSE_NAME, LMS_MODULE_ID } from "../../../../utils/cookiesmanager";
import Shimmer from "../ShimmerComponent";
import { useGetTranslatedText } from "../queries";
import { getTranslatedText } from "../../../../utils/getTranslatedText";

const PostChapterAssessment = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [animate, setAnimate] = useState(false);
  const [show, setShow] = useState(false);
  const [allowLeave , setAllowLeave] = useState(false);
  const [showWarning, setShowWarning] = useState(false);

  const [searchParams] = useSearchParams();

  const courseId = searchParams.get("courseId") || localStorage.getItem(LMS_COURSE_ID);
  const moduleId = searchParams.get("moduleId") || localStorage.getItem(LMS_MODULE_ID);
  const chapterId = searchParams.get("chapterId") || localStorage.getItem(LMS_CHAPTER_ID);
  const courseName = searchParams.get("courseName") || localStorage.getItem(LMS_COURSE_NAME);
  const chapterName =  localStorage.getItem(LMS_CHAPTER_NAME);

  const languageid = localStorage.getItem("l_id") || 1;

  const {data:translatedTextResponse} = useGetTranslatedText(languageid)
          
  const {data:translatedText = []} = translatedTextResponse || {};

  const navigate = useNavigate();

  const { data: postAssessmentChapterQuestion , isLoading , isFetching } =
    useGetPostChapterAssessmentQuestion({ courseId, moduleId , chapterId  , languageid });

  const { mutate , isPending } = useSavePostChapterAssessment();

  const { data: postAssessmentChapterQuestionData } =
    postAssessmentChapterQuestion || {};

  const { response } = postAssessmentChapterQuestionData || {};

  const handleNext = () => {
    const currentQuestion = response?.[activeIndex];

    // block next if unanswered
    if (!selectedAnswers[currentQuestion?.assQuestionId]) {
      toast.error("Please select an answer");
      return;
    }

    // last question → submit
    if (activeIndex === response.length - 1) {
      const payload = {
        courseId,
        moduleId,
        chapterId,
        questionArray: Object.entries(selectedAnswers).map(
          ([assQuestionID, assAnswerID]) => ({
            assQuestionID,
            assAnswerID,
          }),
        ),
      };

      mutate(payload, {
        onSuccess(data) {
          const { status, error } = data;

          if (!status) {
            throw new Error(error);
          }
          setShow(true);
          setActiveIndex((prev) => prev + 1);
        },
        onError(error) {
          const errorMessage =
            error instanceof Error ? error.message : String(error);
          toast(errorMessage, { type: "error" });
        },
        onSettled() {},
      });
      return;
    }

    // normal next
    // setAnimate(true);
    // setTimeout(() => {
    //   setAnimate(false);
      setActiveIndex((prev) => prev + 1);
    // }, 400);
  };

  const handlePrevious = () => {
    if (activeIndex === 0) return;

    // setAnimate(true);
    // setTimeout(() => {
      // setAnimate(false);
      setActiveIndex((prev) => prev - 1);
    // }, 400);
  };

  const handleRedirection = () => {
    setShow(false);
     sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(`/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
    { state: { keepSidebarClosed: true } });
  };

  const handleBack = () => {
    setShowWarning(true);
  }

  const handleContinueAssessment = () => {
  setShowWarning(false);
  setAllowLeave(false);
  }

  const handleExit = () => {
    sessionStorage.removeItem(ASSESSMENT_ALLOWED);
    navigate(`/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`)
  }

  const currentQuestion = response?.[activeIndex];

  const isCurrentQuestionAnswered =
    !!selectedAnswers[currentQuestion?.assQuestionId];

  const handleQuestionAnswer = useCallback((question, option) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [question.assQuestionId]: option.assAnswerId,
    }));
  }, []);

  useEffect(() => {
          // Add a dummy history entry
        window.history.pushState({ guard: true }, "", `${window.location.pathname}?${searchParams.toString()}`);
      
          const handlePopState = () => {
            if (!allowLeave) {
              setShowWarning(true);
      
              // Re-push state to stop navigation
              window.history.pushState(
                { guard: true },
                "",
                window.location.pathname
              );
            }
          };
      
          window.addEventListener("popstate", handlePopState);
      
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
  },[allowLeave])

  useEffect(() => {
  const allowed = sessionStorage.getItem(ASSESSMENT_ALLOWED);

  if (!allowed) {
    navigate(
      `/user/chapter-list?courseId=${courseId}&moduleId=${moduleId}&courseName=${courseName}`,
      { replace: true }
    );
  }
  }, []);

  const isLastQuestion =
  response && activeIndex === response.length - 1;

  return (
    <>
    <div className={styles.page}>
      <HeaderModule
        title={getTranslatedText(translatedText , "key_post_chapter_assessment" , "Post-Chapter Assessment")}
        className={styles["header-title"]}
        onBackClick={handleBack}
      />
      <div className={styles["container-wrapper"]}>
        <div className={styles["content-part"]}>
          <p className={styles.title}>{chapterName}</p>
          <ProgressBar current={activeIndex} total={response?.length} />
         {isLoading || isFetching ?  <Shimmer width="90%" height="324px" borderRadius="14px" /> : <CourseQuestionCards
          questionsList={response}
          handleQuestionAnswer={handleQuestionAnswer}
          activeIndex={activeIndex}
          animate={animate}
          selectedAnswers={selectedAnswers}
          />}
        </div>
        <ToastContainer />
      </div>
      <div className={styles["bottom-wrapper"]}>
        <Button
          label="Previous"
          buttonVariant={BUTTON_VARIANTS.SECONDARY}
          className={styles["button-class"]}
          onClick={handlePrevious}
          disabled={activeIndex === 0 || activeIndex < 0}
          startIcon={
            <img
              className={styles["left-chevron"]}
              src={RightChevron}
              alt="chevron"
            />
          }
        />
        <Button
          label={isLastQuestion ? 'Submit' : getTranslatedText(translatedText ,"label_next","Next")}
          buttonVariant={BUTTON_VARIANTS.PRIMARY}
          className={styles["button-class"]}
          onClick={handleNext}
          disabled={!isCurrentQuestionAnswered || isLoading || isPending}
        />
      </div>
      <ToastContainer />
    </div>
    {show && <ChapterCompleteSuccessfulComponent handleRedirection={handleRedirection} show={show} />}
    {showWarning && <AssessmentExitModal handleContinueAssessment={handleContinueAssessment} handleExit={handleExit} show={showWarning} />}
    </>
  );
};

export default PostChapterAssessment;
